export const successConstants = {
  SET_SUCCESS: "SET_SUCCESS",
  CLEAN_SUCCESS: "CLEAN_SUCCESS",
};
